import React from 'react';
import ReportDataSet, {
  isMissionsReportData,
} from '../../models/general/notifications/report-data-set';
import { DateTime } from 'luxon';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { dateToStringFormat } from '@common/utils/date';
import MissionDetails from '../missions/MissionDetails';
import MissionScaledImage from '../missions/MissionScaledImage';
import PageWithHeaderFooter from './Page';
import PdfWrapper from './PdfWrapper';
import { ReportType } from 'services/analytics-events';

const MissionSummaryReport: React.FC<{
  reportDataSets: ReportDataSet[];
  start: DateTime;
  end: DateTime;
}> = ({ reportDataSets, start, end }) => {
  const { t } = useTranslation();

  const pages =
    reportDataSets.reduce(
      (acc, dataset) => (acc += isMissionsReportData(dataset.data) ? dataset.data.length : 1),
      0,
    ) + 1;

  const timezone =
    reportDataSets.length > 0 &&
    isMissionsReportData(reportDataSets[0].data) &&
    reportDataSets[0].data.length > 0
      ? reportDataSets[0].data[0].timezone
      : DateTime.local().zoneName;

  return (
    <React.Fragment>
      <PdfWrapper
        title={t('notification-trigger-MISSION_SUMMARY')}
        reportType={ReportType.MissionSummary}
        subtitle={`${dateToStringFormat(start, false, timezone)} - ${dateToStringFormat(end, false, timezone)}`}
      >
        {reportDataSets.map((dataset, dsIndex) => {
          if (!isMissionsReportData(dataset.data)) return null;
          return dataset.data.map((mission, mIndex) => (
            <PageWithHeaderFooter
              key={`${dataset.id}-${mission.id}`}
              header={`${t('notification-trigger-MISSION_SUMMARY')} - ${dataset.name}`}
              footer={t('info-sphere-footnote')}
              pages={`${(dsIndex + 1) * (mIndex + 1) + 1} / ${pages}`}
            >
              <Box
                sx={{
                  backgroundColor: '#F2F4F7',
                  mb: 2,
                  pb: 1,
                }}
              >
                <MissionScaledImage mission={mission} maxHeight={264} />
              </Box>
              <MissionDetails mission={mission} />
            </PageWithHeaderFooter>
          ));
        })}
      </PdfWrapper>
    </React.Fragment>
  );
};

export default MissionSummaryReport;
